import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ToastInfo, ToastInitialState } from "../models/Toast";
import { AppThunk } from "./store";


const initialState : ToastInitialState = {
    // Comeca fechado: com `true` o app abria exibindo um toast sem titulo nem
    // mensagem.
    show: false,
    toastInfo: {
      title: '',
      message: '',
      effect: 'success'
    }
}

const toastSlice = createSlice({
  name: "toast",
  initialState,
  reducers: {
    setToastStatus (state, action :PayloadAction<boolean>) {
      state.show = action.payload
    },
    setToastInfo (state, action : PayloadAction<ToastInfo> ) {
      state.toastInfo = action.payload
    }

  }
})

export const {
    setToastStatus,
    setToastInfo
} = toastSlice.actions

export default toastSlice.reducer;

export const openToast = (info: ToastInfo) : AppThunk => (dispatch) => {
  dispatch(setToastStatus(true));
  dispatch(setToastInfo(info));
}